import { objectSchema, StringSchema } from "vue-utils"

export interface KeycloakSettings {
	authority: string
	clientId: string
	audience: string
}
export const KeycloakSettings = objectSchema<KeycloakSettings>({
	authority: String,
	clientId: String,
	audience: String,
})

export interface WasteShippingConfig {
	appName: string
	officeName: string
	officeEmail: string
	fileMimeTypes: string[]
	maxUploadSize: number
	tfsUpcomingDaysBefore: number
	keycloak: KeycloakSettings
}
export const WasteShippingConfig = objectSchema<WasteShippingConfig>({
	appName: String,
	officeName: String,
	officeEmail: String,
	fileMimeTypes: StringSchema.array(),
	maxUploadSize: Number,
	tfsUpcomingDaysBefore: Number,
	keycloak: KeycloakSettings,
})
